import React, { Component } from 'react'
import {
  Modal,
  ModalBackground,
  Delete,
  ModalCard,
  ModalCardBody,
  ModalCardFooter,
  ModalCardHeader,
  ModalCardTitle,
  Button,
  Field, Control, Input, Label, Help
} from 'bloomer'
import { Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'

const CREATE_ROOM = gql`
  mutation ($name: String!, $houseId: UUID!) {
    createRoom(name: $name, houseId: $houseId) {
      room { id }
    }
  }
`

const initialState = {
  name: '',
  error: null
}

export default class AddRoomModal extends Component {
  state = {
    ...initialState
  }

  handleChange = (key) => (evt) => {
    const value = evt.target.value
    this.setState(() => ({[key]: value}))
  }

  handleClose = (evt) => {
    this.setState(() => ({
      ...initialState
    }))

    this.props.handleClose(evt)
  }

  handleSubmit = async (createRoomMutation, evt) => {
    evt.preventDefault()

    const { houseId } = this.props
    const { name } = this.state

    if (name === '') {
      this.setState(() => ({
        error: 'Informe o nome do novo cômodo'
      }))
      return
    }

    try {
      await createRoomMutation({
        variables: {
          name,
          houseId
        }
      })

      this.setState(() => ({
        ...initialState
      }))

      this.props.handleClose(evt)
      this.props.refetch()
    } catch (e) {
      this.setState(() => ({
        error: 'Ocorreu um erro na comunicação com servidor'
      }))
      console.error(e)
    }
  }

  render() {
    const { name, error } = this.state
    const { isActive } = this.props

    return (
      <Modal isActive={isActive}>
        <ModalBackground onClick={this.handleClose}/>
        <Mutation mutation={CREATE_ROOM}>
          {(createRoom, {loading}) => (
            <ModalCard tag="form" onSubmit={this.handleSubmit.bind(this, createRoom)}>
              <ModalCardHeader>
                <ModalCardTitle>Adicionar cômodo</ModalCardTitle>
                <Delete onClick={this.handleClose} />
              </ModalCardHeader>
              <ModalCardBody>
                <Field>
                  <Control>
                    <Label>Nome</Label>
                    <Input type="text" placeholder="Cozinha" isColor={error ? 'danger' : null} autoFocus onChange={this.handleChange('name').bind(this)} value={name} />
                    {error && <Help isColor="danger">{error}</Help>}
                  </Control>
                </Field>
              </ModalCardBody>
              <ModalCardFooter>
                <Button type="submit" isLoading={loading} isColor="success">Adicionar</Button>
                <Button onClick={this.handleClose}>Cancelar</Button>
              </ModalCardFooter>
            </ModalCard>
          )}
        </Mutation>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/DashboardPage/modals/AddRoomModal.js